import { returnTargetFrom, safeReturnTarget } from '@/lib/return-target'

export const tournamentHallTabs = [
  'results',
  'highlights',
  'games',
  'rules',
] as const

export type TournamentHallTab = (typeof tournamentHallTabs)[number]

type HallLocation = {
  pathname: string
  search: string
  hash: string
}

export function readTournamentHallState(search: string) {
  const params = new URLSearchParams(search)
  const requestedTab = params.get('tab')
  const requestedPage = Number(params.get('page'))
  return {
    editionId: params.get('edition') || undefined,
    tab: tournamentHallTabs.find(tab => tab === requestedTab) ?? 'results',
    search: params.get('search') ?? '',
    page:
      Number.isSafeInteger(requestedPage) && requestedPage > 0
        ? requestedPage
        : 1,
  }
}

export function tournamentHallUrl(location: HallLocation) {
  const search = new URLSearchParams(location.search)
  for (const key of [
    'tournament',
    'tournamentView',
    'tournamentSection',
    'view',
    'edition',
    'tab',
    'search',
    'page',
  ])
    search.delete(key)
  if (!location.pathname.endsWith('/hall'))
    search.set('returnTo', returnTargetFrom(location))
  return `/tournaments/hall?${search}${location.hash}`
}

export function tournamentHallReturnTarget(
  location: HallLocation,
  editionId?: string,
) {
  const search = new URLSearchParams(location.search)
  const requested = search.get('returnTo')
  for (const key of [
    'edition',
    'tab',
    'search',
    'page',
    'returnTo',
    'tournamentView',
    'tournamentSection',
  ])
    search.delete(key)
  search.delete('tournament')
  const query = search.toString()
  const fallback = `${editionId ? `/tournaments/${encodeURIComponent(editionId)}` : '/tournaments'}${query ? `?${query}` : ''}${location.hash}`
  return safeReturnTarget(requested, fallback)
}
